import styled from "styled-components";

const TextWrapper = styled.div`
  margin-bottom: 18px;
`;

export default {
  TextWrapper
};
